import React from 'react';
import { GoogleMap } from '@react-google-maps/api';

interface Terminal {
  name: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  coordinates: {
    lat: number;
    lng: number;
  };
}

const terminals: Terminal[] = [
  {
    name: 'Charleston',
    phone: '843-829-2200',
    address: '201 Sigma Dr.',
    city: 'Summerville',
    state: 'SC',
    zip: '29486',
    coordinates: {
      lat: 33.0185,
      lng: -80.1434
    }
  },
    {
    name: 'Dallas',
    phone: '972-910-2250',
    address: '4403 River Oaks Dr.',
    city: 'Dallas',
    state: 'TX',
    zip: '75241',
    coordinates: {
      lat: 33.0185,
      lng: -80.1434
    }
  },
  {
    name: 'Houston',
    phone: '843-829-2201',
    address: '8 Oats Rd.',
    city: 'Houston',
    state: 'TX',
    zip: '77015',
    coordinates: {
      lat: 29.7604,
      lng: -95.3698
    }
  },
  {
    name: 'Savannah',
    phone: '843-829-2202',
    address: '1618 Deans Rd.',
    city: 'Savannah',
    state: 'GA',
    zip: '31408',
    coordinates: {
      lat: 32.0809,
      lng: -81.0912
    }
  },
  {
    name: 'Norfolk',
    phone: '843-829-2203',
    address: '806 Meads Ct.',
    city: 'Norfolk',
    state: 'VA',
    zip: '23323',
    coordinates: {
      lat: 36.8508,
      lng: -76.2859
    }
  },  {
    name: 'Jasksonville',
    phone: '843-829-2200',
    address: '2831 Talleyrand Ave',
    city: 'Jacksonville',
    state: 'FL',
    zip: '32206',
    coordinates: {
      lat: 30.40048,
      lng: -81.54185
    }
  }
];

const mapContainerStyle = {
  width: '100%',
  height: '400px'
};

const center = {
  lat: 33.0185,
  lng: -85.1434
};

const mapOptions = {
  mapId: 'lcg_freight_map',
  disableDefaultUI: true,
  clickableIcons: false,
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: false,
  zoomControl: false,
  gestureHandling: 'none',
  draggable: false
};

const AboutPage: React.FC = () => {
  const onLoad = (map: google.maps.Map) => {
    terminals.forEach((terminal) => {
      // Create a regular marker since AdvancedMarkerElement requires additional setup
      new google.maps.Marker({
        position: terminal.coordinates,
        map: map,
        title: terminal.name,
        animation: google.maps.Animation.DROP
      });
    });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">About LCG Freight</h1>
        <p className="text-xl text-gray-600">
          Serving our customers with excellence across the Southeast United States
        </p>
      </div>

      {/* Map Section */}
      <div className="mb-12 rounded-lg overflow-hidden shadow-lg">
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          zoom={5}
          center={center}
          onLoad={onLoad}
          options={mapOptions}
        >
        </GoogleMap>
      </div>

      {/* Terminals Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
        {terminals.map((terminal) => (
          <div
            key={terminal.name}
            className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow"
          >
            <div className="text-2xl font-bold text-primary mb-2">{terminal.name}</div>
            <div className="space-y-2 text-gray-600">
              <p>{terminal.address}</p>
              <p>{terminal.city}, {terminal.state} {terminal.zip}</p>
              <p className="font-semibold text-primary">{terminal.phone}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Sales Contact Section */}
      <div className="bg-white rounded-lg shadow-lg p-8 text-center">
        <h2 className="text-3xl font-bold text-primary mb-4">Contact Our Sales Team</h2>
        <div className="inline-flex items-center justify-center space-x-2 text-xl text-gray-600">
          <svg
            className="w-6 h-6 text-primary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          <a
            href="mailto:salesgroup@lcgfreight.com"
            className="text-primary hover:text-primary-dark transition-colors"
          >
            salesgroup@lcgfreight.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
